import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id DEAF6AD9-9AB9-4B59-B47D-830357A4B665
 * name alpha-t
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-t.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaTIcon = createSvgIcon(<><path d="M9,7V9H11V17H13V9H15V7H9Z" /></>, 'AlphaTIcon');
export default AlphaTIcon